import { styled, Box } from '@mui/material';

import { FormLabelStyled } from '../FormField/FormFieldStyled';

export const FileFieldWrapperStyled = styled(Box)({
  [`${FormLabelStyled}`]: {
    display: 'none',
  },
});
